import { render, staticRenderFns } from "./LoanOverdue.vue?vue&type=template&id=66ad9363&"
import script from "./LoanOverdue.vue?vue&type=script&lang=js&"
export * from "./LoanOverdue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports